import React from "react";
import styled, { css } from "styled-components/macro";

import { IHouse } from "interfaces/interfaces";
import { IRoomCard, RoomCard } from "../RoomCard";
import { CloseButton } from "../RoomCard/styles";
import { DefaultFont } from "../../../styles/fonts";
import { Root as RoomCardRoot } from "../RoomCard/styles";

interface IRoomsList {
  houses: IHouse[];
  selectedHouse?: IHouse | null;
  onRoomHover?: (house: IHouse) => void;
  onLikedChanged: (house: IHouse) => void;
}

export const Root = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 11px;
  background: white;
  overflow-y: auto;
  padding: 2px 16px 16px 16px;
  box-sizing: content-box;

  ${RoomCardRoot} {
    width: calc(50% - 6px);
  }
`;

const RoomListCard = styled<React.FC<IRoomCard & { selected?: boolean }>>(
  RoomCard
)`
  cursor: pointer;

  ${(props) =>
    props.selected
      ? css`
          outline: 1px solid #6f7f9e;
        `
      : ""};

  ${CloseButton} {
    display: none;
  }
`;

const NoResults = styled.div`
  ${DefaultFont};
  flex-grow: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const RoomsList: React.FC<IRoomsList> = ({
  houses,
  selectedHouse,
  onRoomHover,
  onLikedChanged
}) => {
  return (
    <Root>
      {houses.length === 0 ? (
        <NoResults>No results in this area by your search criteria</NoResults>
      ) : null}
      {houses.map((house) => (
        <RoomListCard
          key={house.house_id}
          selected={selectedHouse?.house_id === house.house_id}
          house={house}
          onHover={onRoomHover}
          onLikedChanged={onLikedChanged}
        />
      ))}
    </Root>
  );
};
